import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ModuleHeader from "../components/ModuleHeader";
import DateDropdown from "@/components/DateDropdown";
import moment from "moment";
// 颜色插值函数（支持Hex → 渐变）
const lerpColor = (start, end, t) => {
    const hexToRgb = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return [r, g, b];
    };
    const [r1, g1, b1] = hexToRgb(start);
    const [r2, g2, b2] = hexToRgb(end);
    const r = Math.round(r1 + (r2 - r1) * t);
    const g = Math.round(g1 + (g2 - g1) * t);
    const b = Math.round(b1 + (b2 - b1) * t);
    return `rgb(${r}, ${g}, ${b})`;
};
// 核心配置（渐变颜色匹配参考）
const config = {
    totalBlocks: 40, // 固定40块
    blockHeight: "0.12rem", // 进度条高度（px）
    blockGap: 0.02, // 块间距（px）
    filledColor: "#00E6F0", // 起始色：亮青色
    gradientEnd: "#B3F9FF", // 结束色：浅青色
    emptyColor: "#2A3A4E", // 未占块：深灰蓝（贴合背景）
    titleWidth: "0.8rem", // 标题固定宽度
    valueWidth: "0.8rem", // 数值固定宽度
};
const maxCount = 5000;
const maxAmount = 30000;
const fetchChartData = async (date) => {
    console.log("Selected time:", date);
    // 数据更新逻辑可在此扩展
};
const AssetInOutStatistics = ({ className = "", initDate = moment().format("YYYY-MM"), }) => {
    const [currentTab, setCurrentTab] = useState(1); // 0:数量 1:金额
    const [isAutoPlay, setIsAutoPlay] = useState(true);
    const [selectedDate, setSelectedDate] = useState(initDate);
    const [loading, setLoading] = useState(true); // 添加加载状态
    const [tableData, setTableData] = useState([
        { title: "月初资产", count: 3489, amount: 25561.68 },
        { title: "本月增加", count: 203, amount: 2643.17 },
        { title: "本月减少", count: 164, amount: 1945.64 },
        { title: "月末资产", count: 3519, amount: 26259.21 },
    ]);
    const amountData = tableData.map((item) => ({
        ...item,
        value: item.amount,
    })) || [];
    const quantityData = tableData.map((item) => ({
        ...item,
        value: item.count,
    })) || [];
    // 自动轮播逻辑
    useEffect(() => {
        let timer = null;
        if (isAutoPlay && tableData.length > 0) {
            // 只有有数据时才启动轮播
            timer = setInterval(() => {
                setCurrentTab((prev) => {
                    if (prev === 1) {
                        return 2;
                    }
                    else {
                        return 1;
                    }
                });
            }, 5000);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [isAutoPlay, tableData]); // 添加tableData依赖
    const data = currentTab === 1 ? quantityData : amountData;
    return (_jsxs("div", { className: `relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.2)]
        flex flex-col h-full nin-h-0 ${className}`, children: [_jsx(ModuleHeader, { title: `资产进出统计-${currentTab === 1 ? "数量" : "金额"}`, children: _jsx(DateDropdown, { initDate: initDate, onDateChange: (date) => fetchChartData(date) }) }), _jsx("div", { className: "flex-1 flex flex-col text-white min-h-0", style: { paddingLeft: "0.1rem", paddingRight: "0.1rem" }, children: data.map((item) => {
                    // 计算填充比例（支持小数）
                    const da = currentTab === 1 ? maxCount : maxAmount;
                    const filledRatio = (item.count / da) * config.totalBlocks;
                    return (_jsxs("div", { className: "flex items-center flex-1", children: [_jsx("div", { className: "text-left font-medium", style: { width: config.titleWidth, fontSize: "0.18rem" }, children: item.title }), _jsx("div", { className: "flex-1 mx-[0.2rem] h-[0.12rem] overflow-hidden", style: {
                                    display: "grid",
                                    gridTemplateColumns: `repeat(${config.totalBlocks}, 1fr)`,
                                    gridGap: `${config.blockGap}rem`,
                                    height: config.blockHeight,
                                }, children: Array.from({ length: config.totalBlocks }).map((_, blockIndex) => {
                                    const isFilled = blockIndex < filledRatio;
                                    let bgColor = config.emptyColor;
                                    if (isFilled) {
                                        // 计算渐变位置：0（左）→1（右）
                                        const gradientPos = blockIndex / (config.totalBlocks - 1);
                                        bgColor = lerpColor(config.filledColor, config.gradientEnd, gradientPos);
                                    }
                                    return (_jsx("div", { style: {
                                            backgroundColor: bgColor,
                                            borderRadius: 0, // 非圆角
                                        } }, blockIndex));
                                }) }), _jsx("div", { className: "text-right whitespace-nowrap", style: { width: config.valueWidth, fontSize: "0.18rem" }, children: `${item.count}${currentTab === 1 ? "项" : "万元"}` })] }, item.title));
                }) }), tableData.length > 0 && (_jsx("div", { className: "tab-indicators flex justify-center items-center space-x-[0.2rem] mb-[0.02rem]", children: [1, 2].map((item) => (_jsx("span", { className: `w-[0.1rem] h-[0.1rem] rounded-full cursor-pointer 
                ${currentTab === item ? "bg-blue-500" : "bg-gray-400"}`, onClick: () => setCurrentTab(item) }, item))) }))] }));
};
export default AssetInOutStatistics;
